// extracted by mini-css-extract-plugin
export default {"holder":"PostItDisplay_holder__2g8Ap","blue":"PostItDisplay_blue__+JN-Z"};